
import React from 'react';
import { assets } from "../../assets/assets";
import "./style/explourTour.css";

function ExplourZoom({ onZoomIn, onZoomOut, onRestart }) {
  return (
    <div className="icon-zoom-tour">
      <div className="icon-tour" onClick={onZoomIn}>
        <img src={assets.zoomIn} alt="Zoom In" className="zoom-icon" />
      </div>
      <div className="icon-tour" onClick={onRestart}>
        <img src={assets.restart} alt="Restart" className="zoom-icon" />
      </div>
      <div className="icon-tour" onClick={onZoomOut}>
        <img src={assets.zoomOut} alt="Zoom Out" className="zoom-icon" />
      </div>
    </div>
  );
}

export default ExplourZoom;